import * as Types from './types';
import { actionTypes } from './constants';

export const updateDeviceAction = (data: Partial<Types.IDeviceState>): Types.IUpdateDeviceAction => ({
    type: actionTypes.UPDATE_DEVICE,
    payload: data
});
